import { Divider, Grid, IconButton, Stack, TextField, Tooltip } from "@mui/material";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";

export default function AddressEntry({
	handleChange,
	handleDateMovedInChange,
	handleDateMovedOutChange,
	addressInformation,
	errors,
	index,
	handleDelete,
	handleSearchResult,
}) {
	const { t } = useTranslation();
	const inputRef = useRef();
	const autoCompleteRef = useRef();
	const options = {
		fields: ["address_components"],
	};
	useEffect(() => {
		autoCompleteRef.current = new window.google.maps.places.Autocomplete(inputRef.current, options);
		autoCompleteRef.current.addListener("place_changed", async function () {
			const place = await autoCompleteRef.current.getPlace();
			console.log(place);
			const country = place.address_components.find((c) => c.types.includes("country"))?.long_name || "";
			const streetLine1 =
				(place.address_components.find((c) => c.types.includes("route"))?.long_name || "") +
				" " +
				(place.address_components.find((c) => c.types.includes("street_number"))?.long_name || "");
			const city = place.address_components.find((c) => c.types.includes("locality"))?.long_name || "";
			const province = place.address_components.find((c) => c.types.includes("administrative_area_level_1"))?.long_name || "";
			const postalCode = place.address_components.find((c) => c.types.includes("postal_code"))?.long_name || "";
			let tempAddress = {};
			tempAddress = { ...tempAddress, country, streetLine1: streetLine1.trim(), city, province, postalCode };
			console.log(tempAddress);
			handleSearchResult(tempAddress, index);
			// setAddress(tempAddress);
		});
	}, []);
	return (
		<Grid item xs={12} container spacing={2} direction={"row"}>
			<Grid item xs={12}>
				<Stack direction="row" alignItems="center">
					<TextField
						className="googleAutocomplete"
						inputRef={inputRef}
						size="small"
						placeholder="Start typing your address here..."
						variant="standard"
						fullWidth
						sx={{ width: { xs: "100%", md: "50%" } }}
					/>
					{index != 0 && (
						<Tooltip title="Delete Address">
							<IconButton
								color="secondary"
								onClick={() => {
									handleDelete(index);
								}}
							>
								<DeleteForeverIcon />
							</IconButton>
						</Tooltip>
					)}
				</Stack>
			</Grid>
			<Grid item xs={12} md={6}>
				<TextField
					sx={{ width: { xs: "100%" } }}
					name="streetLine1"
					label={t("Street Address Line 1")}
					variant="outlined"
					onChange={(e) => {
						handleChange(e, index);
					}}
					value={addressInformation?.streetLine1 || ""}
					error={!!errors?.streetLine1}
					helperText={t(errors?.streetLine1)}
					size="small"
				/>
			</Grid>
			<Grid item xs={12} md={6}>
				<TextField
					sx={{ width: { xs: "100%" } }}
					name="streetLine2"
					label={t("Street Address Line 2")}
					variant="outlined"
					onChange={(e) => {
						handleChange(e, index);
					}}
					value={addressInformation?.streetLine2 || ""}
					helperText={t(errors?.streetLine2)}
					size="small"
				/>
			</Grid>
			<Grid item xs={12} md={6}>
				<TextField
					sx={{ width: { xs: "100%" } }}
					name="city"
					label={t("City")}
					variant="outlined"
					onChange={(e) => {
						handleChange(e, index);
					}}
					value={addressInformation?.city || ""}
					error={!!errors?.city}
					helperText={t(errors?.city)}
					size="small"
				/>
			</Grid>
			<Grid item xs={12} md={6}>
				<TextField
					sx={{ width: { xs: "100%" } }}
					name="province"
					label={t("Province / State")}
					variant="outlined"
					onChange={(e) => {
						handleChange(e, index);
					}}
					value={addressInformation?.province || ""}
					error={!!errors?.province}
					helperText={t(errors?.province)}
					size="small"
				/>
			</Grid>
			<Grid item xs={12} md={6}>
				<TextField
					sx={{ width: { xs: "100%" } }}
					name="postalCode"
					label={t("Postal / Zip Code")}
					variant="outlined"
					onChange={(e) => {
						handleChange(e, index);
					}}
					value={addressInformation?.postalCode || ""}
					error={!!errors?.postalCode}
					helperText={t(errors?.postalCode)}
					size="small"
				/>
			</Grid>
			<Grid item xs={12} md={6}>
				<TextField
					sx={{ width: { xs: "100%" } }}
					name="country"
					label={t("Country")}
					variant="outlined"
					onChange={(e) => {
						handleChange(e, index);
					}}
					value={addressInformation?.country || ""}
					error={!!errors?.country}
					helperText={t(errors?.country)}
					size="small"
				/>
			</Grid>
			<Grid item xs={12} md={6}>
				<LocalizationProvider dateAdapter={AdapterMoment}>
					<DesktopDatePicker
						label={t("Moved In Date")}
						inputFormat="MMM DD YYYY"
						disableMaskedInput
						value={addressInformation?.dateMoveIn || ""}
						onChange={(newValue) => {
							handleDateMovedInChange(newValue, index);
						}}
						renderInput={(params) => (
							<TextField
								// onKeyDown={(e) => {
								// 	e.preventDefault();
								// }}
								sx={{ width: { xs: "100%" } }}
								{...params}
								helperText={t(errors?.dateMoveIn)}
								error={!!errors?.dateMoveIn}
								size="small"
							/>
						)}
						onError={(e) => {
							console.log(e);
						}}
						disableFuture
					/>
				</LocalizationProvider>
			</Grid>
			<Grid item xs={12} md={6}>
				<LocalizationProvider dateAdapter={AdapterMoment}>
					<DesktopDatePicker
						label={t("Moved Out Date")}
						inputFormat="MMM DD YYYY"
						disableMaskedInput
						value={addressInformation?.dateMoveOut || ""}
						name="dateMoveOut"
						onChange={(newValue) => {
							handleDateMovedOutChange(newValue, index);
						}}
						renderInput={(params) => (
							<TextField
								// onKeyDown={(e) => {
								// 	e.preventDefault();
								// }}
								sx={{ width: { xs: "100%" } }}
								{...params}
								helperText={t(errors?.dateMoveOut)}
								error={!!errors?.dateMoveOut}
								size="small"
							/>
						)}
						onError={(e) => {
							console.log(e);
						}}
						minDate={addressInformation?.dateMoveIn}
						disabled={!addressInformation?.dateMoveIn}
						disableFuture
					/>
				</LocalizationProvider>
			</Grid>

			<Grid item xs={12}>
				<Divider />
			</Grid>
		</Grid>
	);
}
